import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import CreateUserLearningAssignmentsForm from '../../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function AddlearningItemsToUsersPage() {
  const { uuids: uuidsStr } = useParams()
  const uuids = useMemo(() => uuidsStr!.split(','), [uuidsStr])

  const { close } = useOutletContext<any>()

  return <CreateUserLearningAssignmentsForm userUuids={uuids} onClose={close} />
})

export function AddlearningItemsToUsersPageBreadcrumb() {
  const { uuids } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.addLearningItemsToUsers.url({ uuids: uuids! })}>{t('manage learning.add learning items')}</Link>
  )
}
